import * as React from 'react';
import AspectRatio from '@mui/joy/AspectRatio';
import SvgIcon from '@mui/joy/SvgIcon';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import { BiPlus } from "react-icons/bi";
import { applySolidInversion } from "@mui/joy/colorInversion";
import { Box } from "@mui/joy";

export default function AddDeviceCard({onClick}) {
    return (
        <Box
            sx={[
                (theme) => ({
                    p: 4,
                    borderRadius: 'sm',
                    background: `linear-gradient(45deg, ${theme.vars.palette.neutral[600]}, ${theme.vars.palette.neutral[400]})`,
                    // Make the container a flex column so that we can push the icon button to the right
                    display: 'flex',
                    flexDirection: 'column',
                    width: 290,
                }),
                applySolidInversion('neutral'),
            ]}
            onClick={onClick}
        >
            <AspectRatio
                data-skip-inverted-colors
                variant="soft"
                color="success"
                ratio="1"
                sx={{ width: 48 }}
            >
                <div>
                    <SvgIcon>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect x="3" y="8" width="18" height="4" rx="1" />
                            <path d="M12 8v13" />
                            <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
                            <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
                        </svg>
                    </SvgIcon>
                </div>
            </AspectRatio>

            <Typography level="h3" marginTop={4} marginBottom={4}>
                Add Device
            </Typography>
            <Typography level="body-sm" marginBottom={4}>
                Add a new device to your location in order to produce more data and get more accurate analytics
                for your decisions
            </Typography>

            {/* Wrap the IconButton in a Box that pushes it to the right */}
            <Box sx={{ display: 'flex' }}>
                <IconButton
                    variant="plain"
                    size="lg"
                    sx={{
                        borderRadius: '50%',
                        ml: 'auto', // pushes the button to the right
                    }}
                >
                    <BiPlus />
                </IconButton>
            </Box>
        </Box>
    );
}
